import { Route, Routes } from 'react-router-dom';
import TrainingDocumentListPage from './list';

export default function TrainingDocumentRouting() {
  return (
    <Routes>
      <Route index element={<TrainingDocumentListPage />} />
    </Routes>
  );
}
